export default __webpack_public_path__ + "static/media/V360_C_BD.a1538d1c.pdf";